import { render, staticRenderFns } from "./PButtonGroup.vue?vue&type=template&id=fe8a7bcc"
import script from "./PButtonGroup.vue?vue&type=script&lang=js"
export * from "./PButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports